var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(" Add prizes ")]),_c('v-card-text',[_c('v-textarea',{attrs:{"hint":"comma separated: name, price, link","outlined":""},model:{value:(_vm.prizes),callback:function ($$v) {_vm.prizes=$$v},expression:"prizes"}})],1),_c('v-card-actions',[_c('v-btn',{on:{"click":_vm.submit}},[_vm._v(" Add Prizes ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }